const redirectTo403 = () => window.location.assign('/errors/403.html');

export default redirectTo403;
